import React from 'react';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

import { Container } from './styles';
import ButtonSp from '../ButtonSp';

export default function ImgPdfView(props) {
  ImgPdfView.propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
  };

  ImgPdfView.defaultProps = {
    title: '',
  };

  const { title, src, visible, setVisible } = props;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = src;
    link.download = 'documento.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container>
      <Dialog
        closable
        closeOnEscape
        header={title}
        visible={visible}
        contentStyle={{ margin: 0, padding: 0, position: 'relative' }}
        style={{ minWidth: '350px', width: '95%' }}
        modal
        blockScroll
        onHide={() => setVisible?.(false)}
      >
        <ButtonSp
          icon="pi pi-download"
          className="p-button-rounded p-button-primary button-download"
          onClick={handleDownload}
          style={{
            position: 'absolute',
            top: 20,
            right: 10,
            zIndex: 1000,
          }}
          tooltip="Baixar PDF"
        />

        <embed src={src} width="100%" height="700px" type="application/pdf" />
      </Dialog>
    </Container>
  );
}
